// src/App.js
import React, { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import Cookies from 'js-cookie';
import serviceWorkerBootstrap from './services/serviceWorkerBootstrap';

import LoginPage from "./pages/LoginPage";
import QuoteRequestsPage from "./pages/QuoteRequestsPage";
import QuoteRequestDetail from "./pages/QuoteRequestDetail";
import SettingsPage from "./pages/SettingsPage";

function PrivateRoute({ children }) {
  const { user, isAuthenticated, initialized } = useContext(AuthContext);
  
  // Show loading while auth is being initialized
  if (!initialized) {
    return <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>;
  }
  
  // Once initialized, check if user is authenticated
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user } = useContext(AuthContext);

  // Initialize service worker when user is authenticated
  useEffect(() => {
    if (user) {
      serviceWorkerBootstrap.initialize({
        onQuoteRefresh: async (payload) => {
          console.log('🔄 Quote refresh triggered by push notification:', payload);
          
          // Dispatch custom event for quote pages to listen to
          window.dispatchEvent(new CustomEvent('pushNotificationRefresh', {
            detail: {
              quote_id: payload.quote_id,
              type: payload.notification_type,
              action: 'refresh_data'
            }
          }));
        }
      }).catch(error => {
        console.error('Failed to initialize service worker:', error);
      });
    }
  }, [user]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/quotes"
        element={
          <PrivateRoute>
            <QuoteRequestsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/quotes/:id"
        element={
          <PrivateRoute>
            <QuoteRequestDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <SettingsPage />
          </PrivateRoute>
        }
      />
      {/* catch-all redirect now has access to `user` */}
      <Route
        path="*"
        element={<Navigate to={user ? "/quotes" : "/login"} replace />}
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
